// extracted by mini-css-extract-plugin
export var closeButton = "_m9-2";
export var closeButtonIcon = "_m9-3";
export var lightboxContent = "_m9-1";
export var lightboxOverlay = "_m9-0";